import defaultVariants from "./defaults";

export default [
  ["vayu-button__loader", "absolute", "inset-0", "m-auto"],
  {
    defaultVariants,
  },
];
